import React, { Fragment } from 'react'

import {
  AlignItems,
  Body1,
  Box,
  Color,
  Display,
  FlexDirection,
  Heading2,
  JustifyContent,
  Space,
} from '@gousto-internal/citrus-react'

import { useIsNDDBannersEnabled } from '@library/delivery-timing/src/hooks/useIsNDDBannersEnabled'

import type { ContentBlockType } from 'routes/BoxPrices/boxPricesConfig'
import { contentBlocks, quotes } from 'routes/BoxPrices/boxPricesConfig'

import { BoxPricesDiscountInfographic } from '../BoxPricesDiscountInformation/BoxPricesDiscountInfographic'
import { BoxPricesDiscountInformation } from '../BoxPricesDiscountInformation/BoxPricesDiscountInformation'
import { BoxPricesQuotationBlock } from './BoxPricesQuotationBlock'
import { ContentBlockNDD } from './ContentBlockNDD'

type ContentBlockProps = {
  block: ContentBlockType
}

type BoxPricesContentProps = {
  activeNumPortion: number
  isTaperedDiscountCurveEnabled: boolean
}

export const ContentBlock = ({ block }: ContentBlockProps) => (
  <Box
    height="100%"
    width="100%"
    maxWidth={['343px', '552px']}
    justifyContent={JustifyContent.Center}
    data-testid="boxPricesContentItem"
  >
    <Heading2 size={[9, 10]} data-testid="boxPricesContentTitle">
      {block.title}
    </Heading2>
    <Space size={2} />
    {block.texts.map((text) => (
      <Fragment key={`box-prices-content-text-${block.title}`}>
        <Body1>{text}</Body1>
        <Space size={3} />
      </Fragment>
    ))}
  </Box>
)

export const BoxPricesContent = ({
  activeNumPortion,
  isTaperedDiscountCurveEnabled,
}: BoxPricesContentProps) => {
  const isNDDBannersEnabled = useIsNDDBannersEnabled()

  const blocks = contentBlocks

  return (
    <Fragment>
      <BoxPricesDiscountInformation isTaperedDiscountCurveEnabled={isTaperedDiscountCurveEnabled}>
        <BoxPricesDiscountInfographic
          activeNumPortion={activeNumPortion}
          isTaperedDiscountCurveEnabled={isTaperedDiscountCurveEnabled}
        />
      </BoxPricesDiscountInformation>

      <Box width="100%" bg={Color.White} data-testid="boxPricesContent">
        <Space size={8} />
        <Box
          display={Display.Flex}
          flexDirection={FlexDirection.Column}
          justifyContent={JustifyContent.SpaceEvenly}
          alignItems={AlignItems.Center}
          paddingBottom={2}
        >
          {isNDDBannersEnabled
            ? ContentBlockNDD
            : blocks.map((contentBlock: ContentBlockType) => (
                <>
                  <ContentBlock
                    key={`box-prices-content-${contentBlock.title}`}
                    block={contentBlock}
                  />
                </>
              ))}
        </Box>
      </Box>

      <Box
        maxWidth="100%"
        display={Display.Flex}
        alignItems={AlignItems.Center}
        flexDirection={FlexDirection.Column}
        justifyContent={JustifyContent.Center}
        data-testing="boxPricesQuotationBlockContainer"
      >
        <Space size={6} />
        {quotes.map((quote, index) => (
          <>
            <BoxPricesQuotationBlock key={`box-prices-quote-${quote.source}`} quote={quote} />
            {index === 0 && <Space size={[6, 6, 8]} />}
          </>
        ))}
      </Box>
    </Fragment>
  )
}
